import React, { useState, useEffect } from 'react';
import useAPI from '../../api';
import { FullSizeColumn, FullSizeFlexBox } from '../../Components/FlexBox';
import getColorHeatByIndex from './Utils/getColorHeatByIndex';
import KanbanGroup from './Components/KanbanGroup';
import FiltersPaper from './Components/FiltersPaper';
import { useAtomValue } from 'jotai';
import { selectedCustomerIdAtom, selectedBranchAtom } from '../../Atoms';

const Kanban = function Kanban({ userRoles }) {
  const API = useAPI();
  const selectedBranch = useAtomValue(selectedBranchAtom);
  const selectedCustomerId = useAtomValue(selectedCustomerIdAtom);
  const isOperator = Boolean(
    userRoles?.find(({ roleId }) => roleId === 'OPERATOR')
  );
  const [stages, setStages] = useState([]);
  const [filters, setFilters] = useState({
    campaignId: localStorage.getItem('kanbanCampaignId') || null,
    operatorId: null,
    customerFullName: '',
  });

  useEffect(() => {
    if (!selectedCustomerId)
      API.getCampaignDividers(
        (result) => {
          setStages(result);
        },
        () => {}
      );
  }, [selectedCustomerId]);

  return (
    <FullSizeColumn
      padding="8px"
      sx={{
        overflowX: 'hidden',
        display: selectedCustomerId ? 'none' : 'flex',
      }}
    >
      <FiltersPaper
        filters={filters}
        setFilters={setFilters}
        isOperator={isOperator}
      />
      <FullSizeFlexBox sx={{ overflowX: 'auto' }} gap="24px" padding="12px">
        {stages
          ?.sort((a, b) => a.advancementThreshold - b.advancementThreshold)
          ?.map(
            (
              { id, name, advancementThreshold, description, lowerThreshold },
              index
            ) => {
              return (
                <KanbanGroup
                  key={id}
                  id={id}
                  campaignId={filters.campaignId}
                  width={
                    stages?.length > 0 ? `${100 / stages.length}%` : '100%'
                  }
                  isFirst={index === 0}
                  isLast={index === stages.length - 1}
                  name={name}
                  advancementThreshold={advancementThreshold}
                  lowerThreshold={lowerThreshold}
                  color={getColorHeatByIndex(index, stages?.length)}
                  filters={filters}
                  description={description}
                  branchId={selectedBranch?.id}
                />
              );
            }
          )}
      </FullSizeFlexBox>
    </FullSizeColumn>
  );
};

export default Kanban;
